export function applyValidationProperties(multilineAddressOptions) {
  return addressForms => {
    if (multilineAddressOptions != null && multilineAddressOptions.fields) {
      var _addressForms$fields;
      const propertiesByTarget = multilineAddressOptions.fields;
      const modifiedFields = (_addressForms$fields = addressForms.fields) == null ? void 0 : _addressForms$fields.map(field => field.target ? overrideFieldValidation(field, propertiesByTarget[field.target]) : field);
      return {
        ...addressForms,
        fields: modifiedFields
      };
    } else {
      return addressForms;
    }
  };
}
function overrideFieldValidation(field, fieldOverrides) {
  if (fieldOverrides && field.validation) {
    return {
      ...field,
      validation: {
        ...field.validation,
        required: fieldOverrides.required ?? field.validation.required
      }
    };
  } else {
    return field;
  }
}
//# sourceMappingURL=apply-validation-properties.js.map